<template>
	<div>
		<article class="media">
			<!-- Intentionally Blank for the line that it adds -->
		</article>
		<article
			v-for="(rw, r_index) in reviews"
			class="media">
			<figure class="media-left">
				<p class="image is-64x64">
					<img src="https://bulma.io/images/placeholders/128x128.png" />
				</p>
			</figure>
			<div class="media-content">
				<div class="content">
					<div>
						<strong v-html="rw.user"></strong
						>&nbsp;&nbsp;<star-rating-input
							:key="rw.created_at + rw.updated_at"
							:text_size_prop="6"
							mode_prop="view"
							:rating_prop="rw.rating"></star-rating-input>
						<div
							class="mt-1"
							v-html="rw.content.description"></div>
						<div>
							<figure
								v-for="(image, i_index) in rw.content.images"
								@click="
									$refs.reviewImagesCarouselModal.activate(
										reviewImagesIndex(r_index, i_index)
									)
								"
								class="image is-96x96 is-inline-block is-clickable mt-1 mb-1 mr-1"
								:class="{ 'ml-1': i_index, 'ml-0': !i_index }">
								<img
									:src="image"
									style="
										object-fit: cover;
										width: 96px;
										height: 96px;
									" />
							</figure>
						</div>
						<small
							class="has-text-grey is-size-7"
							:key="minute_ticker + rw.created_at"
							v-if="rw.created_at == rw.updated_at"
							>Written {{ timeDifference(rw.created_at) }} •
							{{ createdAtDate(rw.created_at) }}&nbsp;&nbsp;{{
								createdAtTime(rw.created_at)
							}}</small
						>
						<small
							class="has-text-grey is-size-7"
							:key="minute_ticker + rw.created_at"
							v-else
							>Edited {{ timeDifference(rw.updated_at) }} •
							{{ createdAtDate(rw.updated_at) }}&nbsp;&nbsp;{{
								createdAtTime(rw.updated_at)
							}}</small
						>
					</div>
				</div>
			</div>
			<div class="media-right">
				<div
					ref="dropdown"
					class="dropdown">
					<div class="dropdown-trigger">
						<button
							@click="
								$refs.dropdown[r_index].classList.toggle('is-active')
							"
							class="button is-white has-text-grey"
							style="border-radius: 1rem">
							<i class="fas fa-ellipsis-v"></i>
						</button>
					</div>
					<div
						@mouseleave="
							$refs.dropdown[r_index].classList.remove('is-active')
						"
						class="dropdown-menu"
						role="menu">
						<div class="dropdown-content">
							<a
								@click="editReviewPrompt(r_index)"
								class="dropdown-item"
								><i class="fas fa-edit"></i>&nbsp;&nbsp;Edit Review</a
							>
							<a
								@click="deleteReviewPrompt(r_index)"
								class="dropdown-item"
								><i class="fas fa-trash-alt"></i>&nbsp;&nbsp;Delete
								Review</a
							>
						</div>
					</div>
				</div>
			</div>
		</article>
		<b-modal
			v-model="isReviewEditorModalActive"
			:width="1500"
			scroll="keep">
			<div class="columns is-centered m-0">
				<div class="column is-10">
					<review-input
						style="border-radius: 5px"
						ref="reviewInput"
						@form-submitted-successfully="deactivateReviewEditorModal()"
						@update-review-section="$parent.updateReviewSection()"
						transition="expand"
						:mode_prop="mode"
						:review_prop="review"
						:review_link_prop="review_link_prop"
						:product_id_prop="product_id_prop"
						:placeholder_prop="placeholder_prop"
						:has_hide_writer_button_prop="false"
						:transaction_code_prop="transaction_code"></review-input>
				</div>
			</div>
		</b-modal>
		<image-carousel-modal
			ref="reviewImagesCarouselModal"
			:autoplay="false"
			:images_prop="reviewImages"></image-carousel-modal>
	</div>
</template>
<style scoped>
	.content > p,
	.content p:not(:last-child) {
		margin-bottom: 0px;
	}

	.content > ul {
		padding: 0 1em;
		list-style-type: disc;
	}

	.content > ol {
		padding: 0 1.25em;
	}

	.is-clickable {
		cursor: pointer;
	}
</style>
<script>
	import axios from "axios";
	axios.defaults.headers.post["X-CSRF-TOKEN"] = window.csrf_token;
	import StarRatingInput from "./StarRatingInput.vue";
	import ReviewInput from "./ReviewInput.vue";
	import ImageCarouselModal from "../ImageManager/ImageCarouselModal.vue";

	let dayjs = require("dayjs");
	let relativeTime = require("dayjs/plugin/relativeTime");
	dayjs.extend(relativeTime);

	export default {
		emits: ["update-review-section"],
		props: {
			mode_prop: String,
			maxReviews_prop: Number,
			review_link_prop: String,
			review_link_api_prop: String,
			reviews_prop: Array,
			product_id_prop: Number,
			placeholder_prop: String,
			is_logged_in_prop: Boolean,
		},
		components: { ImageCarouselModal, StarRatingInput, ReviewInput },
		data() {
			return {
				maxReviews: 6,
				data_reviews: [],
				isReviewEditorModalActive: false,
				isReviewImageModalActive: false,
				reviewIndex: null,
				transaction_code: "",
				minute_ticker: true,
				activeReviewImageIndex: 0,
			};
		},
		computed: {
			mode() {
				if (this.$props.mode_prop) {
					return this.$props.mode_prop;
				}
				return "edit";
			},
			reviews() {
				if (typeof this.$props.reviews_prop != "undefined") {
					return this.$props.reviews_prop;
				} else {
					return this.data_reviews;
				}
			},
			reviewImages() {
				let images = [];
				if (!this.reviews.length) {
					return [];
				}
				this.reviews.forEach((rv, r_index) => {
					rv.content.images.forEach((image, i_index) => {
						images.push(image);
					});
				});
				return images;
			},
			isLoggedIn() {
				if (
					typeof JSON.parse(window.sessionStorage.getItem("logged_in"))
						.value != "undefined"
				) {
					return JSON.parse(window.sessionStorage.getItem("logged_in"))
						.value;
				} else if (typeof this.$props.is_logged_in_prop != "undefined") {
					return this.$props.is_logged_in_prop;
				} else {
					return false;
				}
			},
			review() {
				if (typeof this.reviews[this.reviewIndex] == "object") {
					return this.reviews[this.reviewIndex];
				}
				return null;
			},
		},
		mounted() {
			let _this = this;
			setInterval(function () {
				_this.minute_ticker = new Date().toISOString();
			}, 1000 * 60);
		},
		methods: {
			timeDifference(time) {
				let now = dayjs();
				let past = dayjs(time);
				return past.from(now);
			},
			createdAtDate(created_at) {
				let dayjsCreatedAt = dayjs(created_at);
				let now = dayjs();
				let hours = now.diff(dayjsCreatedAt, "h");

				let format = "";
				if (new Date().getFullYear() == dayjsCreatedAt.format("YYYY")) {
					format = "MMM D";
				} else {
					format = "MMM D YYYY";
				}

				if (parseInt(dayjsCreatedAt.format("D")) == new Date().getDate()) {
					return "Today";
				} else if (
					hours <= 24 &&
					parseInt(dayjsCreatedAt.format("D")) != new Date().getDate()
				) {
					return "Yesterday";
				} else {
					return dayjsCreatedAt.format(format);
				}
			},
			createdAtTime(created_at) {
				return dayjs(created_at).format("h:mmA");
			},
			editReviewPrompt(index) {
				this.reviewIndex = index;
				let payload = {
					code: null,
					content: this.reviews[index].content,
					rating: this.reviews[index].rating,
				};
				console.debug([payload, index]);
				let _this = this;
				if (this.isLoggedIn) {
					_this
						.editReviewCheckPromise(null, index)
						.then(function (res) {
							_this.activateReviewEditorModal(payload);
						})
						.catch(function (res) {
							_this.$buefy.dialog.prompt({
								title: "Enter Transaction Code",
								message:
									"<p>Please enter the transaction code you got when you purchased your product.</p>",
								confirmText: "Check Code",
								type: "is-primary",
								hasIcon: true,
								onConfirm: (code) => {
									_this.transaction_code = code;
									_this
										.editReviewCheckPromise(code, index)
										.then(function (res) {
											payload.code = code;
											_this.activateReviewEditorModal(payload);
										});
								},
							});
						});
				} else {
					_this.$buefy.dialog.prompt({
						title: "Edit Review",
						message:
							"<p>Please enter the transaction code you got when you purchased your product.</p>",
						confirmText: "Check Code",
						type: "is-primary",
						hasIcon: true,
						onConfirm: (code) => {
							_this.transaction_code = code;
							_this
								.editReviewCheckPromise(code, index)
								.then(function (res) {
									payload.code = code;
									_this.activateReviewEditorModal(payload);
								});
						},
					});
				}
			},
			editReview() {},
			editReviewCheckPromise(code, index) {
				let _this = this;
				return axios.post(_this.$props.review_link_prop, {
					method: "edit_check",
					transaction_code: code,
					product: _this.$props.product_id_prop,
					description: _this.reviews[index].content.description,
					updated_at: _this.reviews[index].updated_at,
				});
			},
			editReviewRequest() {},
			deleteReviewPrompt(index) {
				this.reviewIndex = index;
				let _this = this;
				if (this.isLoggedIn) {
					_this
						.editReviewCheckPromise(null, index)
						.then(function (res) {
							_this.$buefy.dialog.confirm({
								title: "Are you sure you want to delete this review?",
								message:
									"<p>It will no longer be visible to the public.</p>",
								confirmText: "Yes, Delete Review",
								type: "is-danger",
								hasIcon: true,
								onConfirm: () => {
									_this.deleteReviewRequest(null, index);
								},
							});
						})
						.catch(function (res) {
							_this.$buefy.dialog.prompt({
								title: "Enter Transaction Code",
								message:
									"<p>Please Enter the code used to write this product below.</p>",
								type: "is-danger",
								hasIcon: true,
								onConfirm: (code) => {
									_this.deleteReviewRequest(code, index);
								},
							});
						});
				} else {
					this.$buefy.dialog.prompt({
						title: "Enter Transaction Code",
						message:
							"<p>Please Enter the code used to write this product below.</p>",
						type: "is-danger",
						hasIcon: true,
						onConfirm: (code) => {
							_this.deleteReviewRequest(code, index);
						},
					});
				}
			},
			deleteReviewRequest(code, index) {
				let _this = this;
				axios
					.post(_this.$props.review_link_prop, {
						method: "delete_review",
						transaction_code: code,
						id: _this.$props.product_id_prop,
						description: _this.reviews[index].content.description,
						updated_at: _this.reviews[index].updated_at,
					})
					.then(function (res) {
						_this.$emit("update-review-section");
						_this.$buefy.dialog.alert({
							type: "is-success",
							title: "Review Deleted!",
							hasIcon: true,
							message: "Your Review has been deleted successfully.",
						});
					})
					.catch(function (error) {
						let message =
							"An error has occured when deleting your review, please try agian later";
						_this.$buefy.dialog.alert({
							type: "is-danger",
							title: "Error!",
							hasIcon: true,
							message: message,
						});
					})
					.then(function (res) {});
			},
			activateReviewEditorModal(payload) {
				//v-modal Editor has to be visible before payload can be submitted
				let _this = this;
				this.isReviewEditorModalActive = true;
				setTimeout(function () {
					console.log(payload);
					_this.$refs.reviewInput.load(payload);
				}, 1);
				this.$nextTick(() => {});
			},
			deactivateReviewEditorModal() {
				this.isReviewEditorModalActive = false;
			},
			reviewImagesIndex(r_index, i_index) {
				//A function to get the number of indexes for a specific image
				r_index = parseInt(r_index);
				i_index = parseInt(i_index);
				console.debug([r_index, i_index]);
				let image_index = 0;
				console.log(this.reviews);
				for (let counter = 0; counter < r_index; counter++) {
					this.reviews[counter].content.images.forEach(
						(image, i_index) => {
							image_index++;
						}
					);
				}
				console.debug(image_index + i_index);
				return image_index + i_index;
			},
		},
	};
</script>
